var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { Service } from '~/core/service';
var RoleService = /** @class */ (function (_super) {
    __extends(RoleService, _super);
    function RoleService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 查询角色资源
     */
    RoleService.prototype.getAllRoles = function (data, page) {
        return this.netService.send({
            server: managementService.roleController.getAllRoles,
            data: data,
            page: page,
        });
    };
    /**
     * 新增角色
     */
    RoleService.prototype.createRole = function (data) {
        return this.netService.send({
            server: managementService.roleController.createRole,
            data: data,
            loading: true,
        });
    };
    /**
     * 修改角色
     */
    RoleService.prototype.updateRole = function (data) {
        return this.netService.send({
            server: managementService.roleController.updateRole,
            data: data,
            loading: true,
        });
    };
    /**
     * 角色分配资源权限
     */
    RoleService.prototype.roleAttachResource = function (roleId, resourceIds) {
        return this.netService.send({
            server: managementService.roleController.roleAttachResource,
            data: {
                resourceIds: resourceIds,
                roleId: roleId
            },
            loading: true,
        });
    };
    /**
     * 获取所有资源控件信息接口
     */
    RoleService.prototype.getAllResources = function () {
        return this.netService.send({
            server: managementService.roleController.getAllResources,
        });
    };
    /**
     * 获取角色资源信息接口
     */
    RoleService.prototype.getSelfResources = function (roleId) {
        return this.netService.send({
            server: managementService.roleController.getSelfResources,
            data: {
                roleId: roleId
            }
        });
    };
    /**
     * 查询所有的角色信息不分页
     */
    RoleService.prototype.getAllRolesList = function () {
        return this.netService.send({
            server: managementService.roleController.getAllRolesList,
        });
    };
    __decorate([
        Inject(NetService)
    ], RoleService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], RoleService.prototype, "getAllRoles", null);
    __decorate([
        Debounce()
    ], RoleService.prototype, "createRole", null);
    __decorate([
        Debounce()
    ], RoleService.prototype, "updateRole", null);
    __decorate([
        Debounce()
    ], RoleService.prototype, "roleAttachResource", null);
    return RoleService;
}(Service));
export { RoleService };
